import request from '@/utils/request'

/** 兼容 { code, data } 与直接返回业务对象 */
export function unwrapHm2(res) {
  if (res == null) return {}
  if (
    typeof res === 'object' &&
    !Array.isArray(res) &&
    Object.prototype.hasOwnProperty.call(res, 'data') &&
    (Object.prototype.hasOwnProperty.call(res, 'code') ||
      Object.prototype.hasOwnProperty.call(res, 'msg') ||
      Object.prototype.hasOwnProperty.call(res, 'message'))
  ) {
    return res.data ?? {}
  }
  return res
}

/** 总览：四钱包、收益、提现状态、门槛等 */
export function getHm2Overview(config = {}) {
  return request({
    url: '/user/hm2/overview/',
    method: 'get',
    ...config,
  })
}

/** 收益/资金明细；wallet: AI算力钱包 / 收益钱包 / 网商银行 / 云智算钱包 */
export function getHm2Earnings(params = {}, config = {}) {
  return request({
    url: '/user/hm2/earnings/',
    method: 'get',
    params,
    ...config,
  })
}

/** 划转信息 / 划转到网商银行 */
export function getHm2Transfer() {
  return request({
    url: '/user/hm2/transfer/',
    method: 'get',
  })
}

export function postHm2Transfer(data) {
  return request({
    url: '/user/hm2/transfer/',
    method: 'post',
    data,
  })
}

/** 提款密码状态 / 设置 */
export function getWithdrawPassword() {
  return request({
    url: '/user/hm2/withdraw-password/',
    method: 'get',
  })
}

export function setWithdrawPassword(data) {
  return request({
    url: '/user/hm2/withdraw-password/',
    method: 'post',
    data,
  })
}

/** 民生保障（均未开放） */
export function getHm2Welfare() {
  return request({
    url: '/user/hm2/welfare/',
    method: 'get',
  })
}

/** 支付宝绑定门槛进度 */
export function getAlipayBindStatus(config = {}) {
  return request({
    url: '/user/hm2/alipay-bind-status/',
    method: 'get',
    ...config,
  })
}

/** 分享：推广码、阶梯进度、团队比例 */
export function getHm2Invite(config = {}) {
  return request({
    url: '/user/hm2/invite/',
    method: 'get',
    ...config,
  })
}

/** AI 算力节点列表 */
export function getHm2Nodes(config = {}) {
  return request({
    url: '/user/hm2/nodes/',
    method: 'get',
    ...config,
  })
}

/** 抢购节点（扣云智算钱包） */
export function buyHm2Node(data) {
  return request({
    url: '/user/hm2/nodes/buy/',
    method: 'post',
    data,
  })
}

/** 公共站点信息（可匿名） */
export function getHm2SiteInfo() {
  return request({
    url: '/user/hm2/site-info/',
    method: 'get',
  })
}

/** 用 overview 拼兼容旧 balances 结构的四钱包 */
export function buildBalancesFromOverview(overview = {}) {
  const o = overview || {}
  const minMap = o.min_withdraw || {}
  const idMap = o.balance_type_ids || {}
  const pickMin = (name, fallback) => {
    const raw = minMap[name]
    const num = Number(raw)
    return Number.isFinite(num) ? num : fallback
  }
  const pickTypeId = (name) => {
    const raw = idMap[name]
    const num = Number(raw)
    return Number.isFinite(num) && num > 0 ? num : null
  }
  return [
    {
      type: 'AI算力钱包',
      type_name: 'AI算力钱包',
      type_id: pickTypeId('AI算力钱包'),
      balance_type_id: pickTypeId('AI算力钱包'),
      amount: o.ai_wallet ?? 0,
      is_withdraw: !!o.withdraw_enabled,
      min_withdraw: pickMin('AI算力钱包', 1),
    },
    {
      type: '云智算钱包',
      type_name: '云智算钱包',
      type_id: pickTypeId('云智算钱包'),
      balance_type_id: pickTypeId('云智算钱包'),
      amount: o.cloud_wallet ?? 0,
      is_withdraw: !!o.withdraw_enabled,
      min_withdraw: pickMin('云智算钱包', 1),
    },
    {
      type: '网商银行',
      type_name: '网商银行',
      type_id: pickTypeId('网商银行'),
      balance_type_id: pickTypeId('网商银行'),
      amount: o.bank_wallet ?? 0,
      is_withdraw: !!o.withdraw_enabled,
      min_withdraw: pickMin('网商银行', 1),
    },
    {
      type: '收益钱包',
      type_name: '收益钱包',
      type_id: pickTypeId('收益钱包'),
      balance_type_id: pickTypeId('收益钱包'),
      amount: o.earning_wallet ?? 0,
      total_income: o.total_income ?? o.earning_wallet ?? 0,
      today_amount: o.today_income ?? 0,
      yesterday_amount: o.yesterday_income ?? 0,
      // 收益钱包单独开放提现
      is_withdraw: !!(o.earning_withdraw_enabled ?? o.withdraw_enabled ?? true),
      min_withdraw: pickMin('收益钱包', 10),
    },
  ]
}
